import { Box, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Search } from '@mui/icons-material';
import { colors } from '../../assets/utils/constants';

const CustomTextFieldFilter = ({ width, label, type, handleFilter }) => {
    return (
        <>
            <Box
                sx={{
                    overflow: 'hidden',
                    width: width ? width : 250,
                    display: {
                        xs: 'none',
                        sm: 'block',
                    },
                }}
            >
                <TextField
                    fullWidth
                    color='secondary'
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        ),
                    }}
                    type={type ? type : 'text'}
                    variant="outlined"
                    size="small"
                    placeholder={label}
                    onKeyUp={(e) => handleFilter(e.target.value)}
                    sx={{
                        '&.MuiFormControl-root': {
                            bgcolor: colors.bgColor1,
                        },
                        '& input': {
                            fontSize: 14,
                        },
                        '& .MuiInputBase-root': {
                            height: 35,
                        },
                    }}
                />
            </Box>
        </>
    );
};

export default CustomTextFieldFilter;
